import { reactive } from "vue";
import { useFeacturesRouter } from "../useFeacturesRouter";

/**
 * Crea un istanza di una tabs, gestendo l'aggiornamento dell'url
 * I dati reattivi non sono direttamente modificabili.
 * Ma possono essere aggiornati solo chiamando i metodi interni.
 * Poichè oltre all'aggiornamento del valore gestiscono l'aggiornamento
 * dei riferimenti nell'url
 *
 * Per leggere invece il valore si consiglia di usare i relativi metodi get, cosi da non dover aggiungere .value ad ogni proprietà
 *
 * Come parametri oltre al json delle tabs e la tabs attiva di default, usa il booleano have_feacture. Se true vuol dire che è una funzionalità richiamabile via URL.
 * @param tabs
 * @param tabAttiva
 * @param have_feature
 */
export function useDefineTab(tabs, tabAttiva, have_feature = true) {
  const {haveAzione, pushAction, registerFeacture, deleteAction} = useFeacturesRouter()

  const data = reactive({
    tabs: tabs,
    tabAttiva: tabAttiva
  })

  /**
   * Ritorna le tabs
   */
  const getTabs = () => data.tabs;

  /**
   * Ritorna il valore della tab attiva
   */
  const getTabAttiva = () => data.tabAttiva;

  /**
   * Aggiorna proprietà dell'elenco di tab
   */
  function updateTabs(tabsRef, {isDisable = false, isHide = false, haveAlert = false, alertText = null}) {
    (data.tabs).map((obj) => {
      if (tabsRef.includes(obj.controls)) {
        obj['disabled'] = isDisable;
        obj['hide'] = isHide;
        obj['haveAlert'] = haveAlert;
        obj['alertText'] = alertText;
      }
    })
  }


  /**
   * Agggiorna il valore della tab attiva
   * usato solo in caso di lettura funzionalità via URL.
   * @param tab
   */
  const initToggle = async(tab) => data.tabAttiva = tab


  /**
   * Aggiorna il valore della tab attiva
   * @param tab
   */
  const toggle = async(tab) => {
    data.tabAttiva = tab
    if(have_feature) {
      await _checkTabInUrl(tab)
      await pushAction(tab);
    }
  }

  /**
   * Controlla nell'url se esiste una voce relativa alla tabs e la rimuove
   * @return {Promise<void>}
   * @private
   */
  async function _checkTabInUrl(tab) {
    for (const tabItem of data.tabs) {
      if(haveAzione(tabItem.controls)) {
        await deleteAction(tabItem.controls, tab);
      }
    }
  }

  // init della funzionalità della modale via URL
  if(have_feature) {
    (data.tabs).forEach((tab) => {
      registerFeacture(tab.controls, initToggle, {tab: tab.controls});
    })
  }

  return {
    getTabs,
    getTabAttiva,
    toggle,
    updateTabs,
    initToggle
  }
}